import React from "react";

export const ChargingSites = [
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">Opening bio-LNG-installatie</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source src="videos/Opening bio-LNG-installatie.mp4" type="video/mp4" />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-multi-modular-shell-site-success-story-video-01.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">
      Shell LNG - tomorrow's fuel today. A new, cleaner, transport fuel |
      Natural Gas
    </h4>
    <div class="video_container">
      <video width="320" height="240" controls poster="videos/multi-modular-shell-charging-site-lng.jpg">
        <source
          src="videos/Shell LNG - tomorrow's fuel today. A new, cleaner, transport fuel   Natural Gas.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-multi-modular-shell-site-success-story-video-02.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
  <h4 className="slideTitle">Snel en duurzaam opladen bij Shell | #MakeTheFuture</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/Snel en duurzaam opladen bij Shell.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-multi-modular-shell-site-success-story-video-03.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
  <h4 className="slideTitle">Rijden op waterstof | Station Den Ruygenhoek</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/Rijden op waterstof   Station Den Ruygenhoek.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-multi-modular-shell-site-success-story-video-04.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">Energiebesparend Shell-station</h4>
    <div className="slideText">
      <p>
        Minder energie verbruiken verlaagt de uitstoot van CO₂. Shell streeft
        ernaar om de CO₂-voetafdruk van de Shell-stations in Nederland voor 2025
        te halveren. Dat betekent dat je vandaag al aan de slag moet. Zo worden
        alle stations op dit moment al voorzien van groene stroom. Daarnaast is
        het in juli 2019 geopende energiezuinige station in Tilburg wederom een
        stap in die richting.
      </p>
      <p>
        Dit Shell-station, aan de Burgemeester Letschertweg in Tilburg, bevat
        isolatieglas en energiezuinige apparatuur. Een warmtepomp en een systeem
        dat warmte terugwint, zorgen voor het juiste klimaat in het station. 164
        Zonnepanelen op het dak wekken de benodigde stroom op. Daarbij worden ze
        geholpen door nog eens 125 m² aan in de luifel geïntegreerde
        zonnepanelen. Deze in de luifel verwerkte zonnepanelen zijn doorzichtig.
        Daardoor is er minder kunstlicht nodig. Hoe meer licht er binnenvalt,
        hoe meer het kunstlicht dimt. Het station is na Peulwijk Oost aan de A4
        bij Delft, het tweede energiezuinige Shell-station en er zullen er meer
        volgen. Bij station Peulwijk is de CO₂-uitstoot al met 35 procent
        gereduceerd.
      </p>
    </div>
    <div className="slideImage">
      <img
        src="images/04aee5ad-88b4-4287-b6ac-05a2bd41c815-cropped.jpg"
        alt=""
        width="560"
        height="auto"
      />
    </div>
  </div>,
  <>
    <h4 className="slideTitle">
      Shell Renewable Diesel nu beschikbaar voor de transportsector op 13
      Nederlandse Shell Truck locaties
    </h4>
    <div className="slideContainer slide_solidColour d-block">
      <p>
        Klanten, die actief zijn in de transportsector, kunnen nu ook Shell
        Renewable Diesel (HVO) tanken op 13 geselecteerde tankstations in
        Nederland. Hierdoor helpt Shell de CO<sub>2</sub>e emissies van haar klanten te
        verlagen. Reducties tot 90% zijn hierbij mogelijk ten opzichte van
        normale diesel. Shell biedt, naast Bio-LNG, nu ook een alternatief voor
        diesel en antwoordt hiermee op de alsmaar groeiende vraag naar
        duurzamere brandstoffen. Het bedrijf overweegt haar Renewable Diesel in
        de toekomst ook aan te bieden op meerdere sites in haar truck netwerk.
      </p>
      <p>
        “Het lijkt dat de energietransitie in Nederland meer en meer aan
        momentum wint. Klanten vragen ons steeds vaker te helpen hun emissies te
        verlagen. Zo ook onze klanten in de transportsector, die hun
        vrachtwagens steeds vaker op Renewable Diesel of Bio-LNG willen laten
        rijden,” zegt Sandra Geilings, Cluster Manager Benefrux van Shell
        Commercial Road Transport. “Shell Hernieuwbare Diesel kan zonder
        motorische aanpassingen in moderne vrachtwagens getankt worden. De CO<sub>2</sub>e
        emissies kunnen met tot 90%1 verlaagd worden als je het vergelijkt met
        gewone diesel.”
      </p>
      <p>
        Shell Renewable Diesel is een schoner verbrandend alternatief voor EN590
        dieselbrandstof. Door het hoge cetaangetal vermindert Shell Renewable
        Diesel ook de lokale emissies (NOx en fijnstof) en verlaagt tevens het
        motorgeluid. Deze brandstof verbetert ook de koude start van de motor.
      </p>
    </div>
  </>,
  <>
    <h4 className="slideTitle">
      Shell opens first Hydrogen Refuelling Station for trucks in the
      Netherlands
    </h4>
    <div className="slideContainer slide_solidColour d-block">
      <p>
        Today Shell opened its first public hydrogen refuelling station (HRS)
        for trucks in the Netherlands. The HRS Emmen at the GZI Next green
        energy hub, located in the northeast of the country, is part of a
        European hydrogen network for heavy-duty road transport. This will
        enable the (inter)national transport sector to become more sustainable
        faster.
      </p>
      <p>
        "With the opening of the hydrogen filling point, we are taking the next
        step in the application of hydrogen," says Tjisse Stelpstra, deputy of
        the Province of Drenthe, home to Emmen. "We have a leading position in
        Drenthe when it comes to hydrogen. We want to further strengthen this
        leading position, preferably across the board. In addition to the
        production of hydrogen, I am talking about the application of hydrogen
        in, for example, the manufacturing industry and in mobility."
      </p>
      <p>
        Last summer, Shell opened the first hydrogen refuelling station for
        regional bus traffic, together with partners for bus operator Qbuzz in
        Groningen. This public transport company will also refuel in Emmen,
        using the new location for its ten new hydrogen busses, co-financed by
        the province. Apart from the busses, all hydrogen-powered trucks will be
        able to fill up at Shell's HRS in Emmen.
      </p>
      <p>
        Marjan van Loon, President-Director of Shell Netherlands, sees hydrogen
        as one of the most important opportunities to help entrepreneurs in
        logistics to move forward in the energy transition. "Hydrogen is an
        important part of our mosaic of solutions. It is now up to our customers
        to make the best choice for them."
      </p>
      <p>
        The hydrogen refuelling station has received subsidies from the Horizon
        2020* research and innovation programme of the European Union,
        entrepreneurship platform Hydrogen Europe and innovations promotor
        Hydrogen Europe Research.
      </p>
      <p>
        <em>
          * Fuel Cells and Hydrogen 2 Joint Undertaking (FCH-JU),
          https://cordis.europa.eu/project/id/875090 part of the Horizon 2020
          programme
        </em>
      </p>
    </div>
  </>,
];
